import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tab1',
  templateUrl: 'tab1.page.html',
  styleUrls: ['tab1.page.scss']
})
export class Tab1Page {
  language= localStorage.getItem("language_select");
  constructor(private _translate: TranslateService) {}
  languageChange()
  {
    localStorage.setItem("language_select",this.language)
    this._translate.use(this.language); 
  }
}
